// Cart item variant title fix
    function cleanVariantTitle(item) {
        if (!item.variant_title) return '';
        let title = item.variant_title;
        title = title.replace(/Dev only \/ JPG/, 'Dev only');
        title = title.replace(/Dev only \/ TIFF/, 'Dev only');
        title = title.replace(/Dev only \/ Dev only/, 'Dev only');
        return title;
    }
